/**
 * Static legal/marketing page content — one place to maintain.
 * All content is authoritative for launch; hukuk incelemesi öncesi taslak.
 */

const COMPANY = "SanoStudent";
const DOMAIN = "bursluluksinavi.com";
const EMAIL = "{EMAIL}";
const KVKK_EMAIL = "{KVKK_EMAIL}";

export const STATIC_PAGES = {
  "nasil-calisir": {
    title: "Nasıl Çalışır?",
    seoTitle: "SanoStudent Nasıl Çalışır — Bursluluk Sınavı & Deneme Platformu",
    description: "SanoStudent nasıl kullanılır? Öğrenci, veli ve okul için adım adım rehber.",
    hero: "SanoStudent, öğrenci, veli ve okulları güvenli tek dijital platformda buluşturur.",
    sections: [
      { h: "Veliler İçin", p: "Cep numaranızla SMS doğrulama ile kayıt olun, çocuklarınızı ekleyin, bursluluk sınavlarına başvurun. Deneme sınavlarına katılabilir, performans raporlarını inceleyebilir ve okullardan gelen davetleri görebilirsiniz." },
      { h: "Öğrenciler İçin", p: "Kendi hesabınızla giriş yapıp deneme sınavlarına katılın, çıkmış soruları çözün, konu bazlı performansınızı takip edin ve AI destekli tercih önerilerini görün." },
      { h: "Okullar İçin", p: "Okulunuzu ücretsiz listeleyin, bursluluk sınavı açın, aday velilerle iletişime geçin ve modüller (analitik, mesajlaşma, hedefleme) ile büyümenizi hızlandırın." },
      { h: "3 Adımda Başla", p: "1) Ücretsiz kayıt · 2) İhtiyaç modülünü seç · 3) Başvur ya da başvuru al. Her adım Türkçe rehberdir." },
    ],
  },
  "hakkimizda": {
    title: "Hakkımızda",
    seoTitle: "Hakkımızda — SanoStudent",
    description: "SanoStudent'in misyonu, vizyonu ve ekibi.",
    hero: "Türkiye'nin bursluluk ve okul seçimi için tasarlanmış dijital eğitim platformu.",
    sections: [
      { h: "Misyonumuz", p: "Her öğrencinin hak ettiği fırsata güvenli, şeffaf ve veri odaklı bir dijital süreçle ulaşmasını sağlamak. Ailelere doğru kararı verecek bilgi, okullara da doğru öğrenciyi bulacak araçları sunmak." },
      { h: "Vizyonumuz", p: "Türkiye'nin özel okul-öğrenci buluşmasının standart altyapısı olmak. Yapay zekâ ile kişiselleştirilmiş eğitim rehberliğini yaygınlaştırmak." },
      { h: "Değerlerimiz", p: "Şeffaflık · Öğrenci verisinde KVKK uyumu · Bilimsel ve ölçülü dil · Reklam-içerik ayrımı · Eğitim ekosistemine katkı." },
      { h: "İletişim", p: `Her türlü öneri için ${EMAIL} adresinden ekibimize ulaşabilirsiniz.` },
    ],
  },
  "iletisim": {
    title: "İletişim",
    seoTitle: "İletişim — SanoStudent",
    description: "SanoStudent ile iletişime geçin: destek, iş birliği ve öneri.",
    hero: "Bize ulaşın — 1 iş günü içinde geri döneriz.",
    sections: [
      { h: "Genel & Destek", p: `E-posta: ${EMAIL}` },
      { h: "KVKK Başvuruları", p: `E-posta: ${KVKK_EMAIL} — 6698 sayılı KVKK kapsamındaki talepleriniz için.` },
      { h: "Okullara Özel", p: "Okulunuzu eklemek veya modül almak için 'Okullar İçin' sayfamızı ziyaret edin. Kurumsal iş birliği: destek@sanostudent.com" },
      { h: "Şirket", p: `${COMPANY} — ${DOMAIN}` },
    ],
  },
  "sss": {
    title: "Sıkça Sorulan Sorular",
    seoTitle: "SSS — SanoStudent Bursluluk Sınavı",
    description: "SanoStudent hakkında sıkça sorulan sorular ve yanıtları.",
    hero: "Kısa yanıtlarla en çok merak edilenler.",
    sections: [
      { h: "SanoStudent ücretli mi?", p: "Kayıt ve temel kullanım ücretsizdir. Bazı premium modüller ve okul abonelikleri ücretlidir; ücretlendirme her sayfada şeffaftır." },
      { h: "Çocuğumun bilgileri güvende mi?", p: "Tüm veriler KVKK'ya uygun işlenir; okullar açık rıza dışı iletişim bilgisine erişemez. Aydınlatma metnimizi inceleyin." },
      { h: "Bursluluk garantisi veriyor musunuz?", p: "Hayır. Platform yalnızca aday öğrencileri okullarla buluşturur. Bursluluk kararı okulun kendisine aittir." },
      { h: "Sınav güvenliği nasıl sağlanıyor?", p: "Sunucu saatiyle senkronize sayaç, kopya davranış tespiti, oturum kontrolleri ve otomatik gönderim ile kurallar korunur." },
      { h: "Ödeme güvenli mi?", p: "Ödemeler iyzico altyapısı üzerinden PCI uyumlu olarak alınır. Kart bilgileri sunucularımızda saklanmaz." },
      { h: "Aboneliğimi nasıl iptal ederim?", p: "Panel > Aboneliğim üzerinden istediğiniz zaman iptal edebilirsiniz. Kalan gün sonuna kadar hizmet devam eder." },
      { h: "Hesabımı silebilir miyim?", p: "Evet. Panel > Güvenlik > Hesabımı Sil ile tüm verileriniz KVKK gereği silinir." },
    ],
  },
  "paketler": {
    title: "Paketler & Fiyatlandırma",
    seoTitle: "Paketler & Fiyatlandırma — SanoStudent",
    description: "Öğrenci, veli ve okullar için abonelik ve modül fiyatları.",
    hero: "İhtiyacınıza uygun paketi seçin — istediğinizde yükseltin veya iptal edin.",
    sections: [
      { h: "Veli & Öğrenci Planları", p: "Başlangıç (ücretsiz), Orta (aylık kotalı premium), İleri (sınırsız erişim). Detaylı fiyatlar Panel > Aboneliğim sayfasında görünür." },
      { h: "Okul Modülleri", p: "Duyuru, Analitik, Kendi Deneme, Galeri, Broşür, Mesajlaşma, Öğrenci Hedefleme — modül bazlı aylık veya yıllık (2 ay bedava) ödeme." },
      { h: "Ödeme", p: "iyzico ile TL ödeme. Fatura otomatik gönderilir." },
      { h: "İptal & İade", p: "İptal her an yapılabilir; iade koşulları için İade-İptal Politikasına bakın." },
    ],
  },
  "kvkk-aydinlatma-metni": {
    title: "KVKK Aydınlatma Metni",
    seoTitle: "KVKK Aydınlatma Metni — SanoStudent",
    description: "6698 sayılı KVKK kapsamında SanoStudent aydınlatma metni.",
    hero: `${COMPANY} olarak kişisel verilerinizin güvenliği önceliğimizdir.`,
    sections: [
      { h: "Veri Sorumlusu", p: `${COMPANY} (${DOMAIN}) — 6698 sayılı KVKK kapsamında veri sorumlusudur.` },
      { h: "İşlenen Kişisel Veriler", p: "Ad, soyad, cep telefonu, e-posta, il/ilçe, çocuk profili (sınıf, hedef okul, sınav skorları), performans verileri, ödeme kayıtları, IP ve cihaz bilgileri." },
      { h: "İşleme Amaçları", p: "Üyelik, bursluluk başvuru yönetimi, sınav düzenleme, performans raporlama, ödeme, bildirim, hukuki yükümlülük ve platform güvenliği." },
      { h: "Hukuki Sebepler", p: "Sözleşmenin ifası, kanuni yükümlülük, meşru menfaat ve açık rıza (pazarlama ve profilleme için)." },
      { h: "Aktarım", p: "Verileriniz yalnızca açık rıza veya sözleşme gereği yetkili okul/hizmet sağlayıcılarla paylaşılır. Yurt dışı aktarım yalnızca KVKK 9. madde koşullarıyla yapılır." },
      { h: "Haklarınız", p: `KVKK 11. madde kapsamında bilgi alma, düzeltme, silme, işleme itiraz, veri taşıma haklarınızı ${KVKK_EMAIL} adresine yazılı olarak iletebilirsiniz.` },
      { h: "Saklama Süresi", p: "Yasal saklama süreleri sonunda veriler silinir veya anonimleştirilir." },
      { h: "Güncelleme", p: "Bu metin güncellendiğinde yayın tarihi değişir; önemli değişiklikler bildirilir." },
    ],
  },
  "gizlilik-politikasi": {
    title: "Gizlilik Politikası",
    seoTitle: "Gizlilik Politikası — SanoStudent",
    description: "Gizlilik ilkelerimiz ve veri güvenliği uygulamalarımız.",
    hero: "Verilerinizi nasıl topladığımızı, işlediğimizi ve koruduğumuzu anlatıyoruz.",
    sections: [
      { h: "Topladığımız Bilgiler", p: "Kayıt sırasında verdiğiniz iletişim, profil ve çocuk bilgileri; kullanım sırasında oluşan performans ve cihaz verileri." },
      { h: "Kullanım Amacı", p: "Hizmet sağlama, iletişim, güvenlik, ürün geliştirme ve yasal yükümlülük." },
      { h: "Çerezler", p: "Deneyimi iyileştirmek için gerekli çerezler ile açık rıza sonrası analitik/pazarlama çerezleri kullanılır. Çerez Politikamıza bakın." },
      { h: "3. Taraflar", p: "Ödeme (iyzico), SMS (Netgsm), e-posta (Resend), analitik (Google) ile veri işleyici sıfatıyla çalışılır." },
      { h: "Güvenlik", p: "TLS, hash'li parolalar, tekil oturum kontrolü, izinli erişim ve düzenli yedekleme ile veriler korunur." },
      { h: "Çocuk Verileri", p: "18 yaş altı öğrenci hesapları veli onayına tabidir. Öğrenciye pazarlama iletişimi gönderilmez." },
      { h: "İletişim", p: `Sorular için ${KVKK_EMAIL}.` },
    ],
  },
  "cerez-politikasi": {
    title: "Çerez Politikası",
    seoTitle: "Çerez Politikası — SanoStudent",
    description: "SanoStudent web sitesinde kullanılan çerezler.",
    hero: "Deneyiminizi kişiselleştirmek ve platformumuzu geliştirmek için çerez kullanıyoruz.",
    sections: [
      { h: "Zorunlu Çerezler", p: "Oturum, güvenlik ve temel işlevler için gereklidir; kapatılamaz." },
      { h: "İşlevsel Çerezler", p: "Dil, tema ve tercih hatırlama gibi kolaylıklar için kullanılır." },
      { h: "Analitik Çerezler", p: "Sayfa görüntüleme, tıklama gibi anonim istatistikler için — yalnızca açık rıza ile." },
      { h: "Pazarlama Çerezleri", p: "İlgi alanına dayalı reklam için — yalnızca açık rıza ile." },
      { h: "Yönetim", p: "Tarayıcı ayarlarınızdan çerezleri istediğiniz zaman silebilirsiniz." },
    ],
  },
  "kullanim-sozlesmesi": {
    title: "Kullanım Sözleşmesi",
    seoTitle: "Kullanım Sözleşmesi — SanoStudent",
    description: "SanoStudent platformunun kullanım koşulları.",
    hero: "SanoStudent'i kullanarak aşağıdaki koşulları kabul etmiş olursunuz.",
    sections: [
      { h: "Taraflar", p: `Bu sözleşme ${COMPANY} ile platformu kullanan gerçek/tüzel kişi ("Kullanıcı") arasındadır.` },
      { h: "Hizmet Kapsamı", p: "Bursluluk sınavı listeleme, başvuru, deneme sınavı, performans raporu, tercih önerisi ve okul-veli iletişim modülleri." },
      { h: "Kullanıcı Yükümlülükleri", p: "Doğru bilgi vermek, başkasının bilgilerini izinsiz paylaşmamak, sınav kurallarına uymak, telif ihlali yapmamak." },
      { h: "Ücretlendirme", p: "Ücretli hizmetler her sayfada belirtilir; ödeme onayı ile hizmet aktif olur." },
      { h: "Sorumluluk", p: "Platform, iletim gecikmeleri ve mücbir sebeplerden doğan kayıplardan sorumlu tutulamaz. Bursluluk kararı okullara aittir." },
      { h: "Fesih", p: "Hesabınızı istediğiniz zaman silebilirsiniz. Kural ihlali halinde platform hesabı askıya alabilir." },
      { h: "Uygulanacak Hukuk", p: "İşbu sözleşme Türkiye Cumhuriyeti hukukuna tabidir. İstanbul Mahkemeleri yetkilidir." },
    ],
  },
  "mesafeli-satis-sozlesmesi": {
    title: "Mesafeli Satış Sözleşmesi",
    seoTitle: "Mesafeli Satış Sözleşmesi — SanoStudent",
    description: "Online abonelik ve modül satışları için mesafeli satış sözleşmesi.",
    hero: "6502 sayılı Tüketicinin Korunması Hakkında Kanun kapsamında mesafeli satış hükümleri.",
    sections: [
      { h: "Satıcı", p: `${COMPANY} — ${DOMAIN} — ${EMAIL}` },
      { h: "Konu", p: "Kullanıcının seçtiği abonelik/modülün elektronik ortamda satışı." },
      { h: "Bedel & Ödeme", p: "Ürün bedeli TL olarak ödeme anında görüntülenir. iyzico üzerinden kredi kartı ile ödeme alınır." },
      { h: "Teslim", p: "Dijital hizmet olduğundan ödeme onayı anında aktif olur; ayrı fiziki teslim yoktur." },
      { h: "Cayma Hakkı", p: "6502 sayılı Kanun'un 15/(g) maddesi gereği elektronik ortamda anında ifa edilen hizmetlerde cayma hakkı bulunmaz. Kullanıcı satın alma sırasında bu bilgiyi teyit eder." },
      { h: "Fatura", p: "Fatura kayıt e-postanıza gönderilir." },
      { h: "Uyuşmazlık", p: "Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir." },
    ],
  },
  "iade-iptal": {
    title: "İade & İptal Politikası",
    seoTitle: "İade & İptal Politikası — SanoStudent",
    description: "Abonelik iptali ve iade koşulları.",
    hero: "Adil ve şeffaf iade/iptal kurallarımız.",
    sections: [
      { h: "İptal", p: "Aboneliğinizi Panel > Aboneliğim üzerinden istediğiniz zaman iptal edebilirsiniz. Kalan gün sonuna kadar hizmet devam eder; yenileme kesilir." },
      { h: "İade", p: "Dijital hizmetlerde satın alma anında ifaya başlandığından yasal cayma hakkı yoktur (bkz. Mesafeli Satış Sözleşmesi). İstisnai durumlarda (teknik hata, çift ödeme) 14 gün içinde destek@sanostudent.com ile iletişime geçin; inceleme sonrası iade işlenir." },
      { h: "Kısmi Kullanım", p: "Kullanılmış modül veya kredi için iade yapılmaz; kullanılmamış tam dönem için istisnai koşullarla kısmi iade değerlendirilir." },
      { h: "Süre", p: "Onaylanan iadeler 14 iş günü içinde aynı kartınıza aktarılır." },
    ],
  },
  "ticari-elektronik-ileti": {
    title: "Ticari Elektronik İleti İzni",
    seoTitle: "Ticari Elektronik İleti — SanoStudent",
    description: "6563 sayılı Kanun kapsamında ticari e-ileti izni.",
    hero: "Kampanya ve tanıtım iletişimi için açık rıza koşulları.",
    sections: [
      { h: "İzin Kapsamı", p: "Kayıt sırasında verdiğiniz açık rıza ile SanoStudent size e-posta/SMS/push ile kampanya, indirim ve içerik önerileri gönderebilir." },
      { h: "Red & İptal", p: "Panel > Ayarlar > Bildirim Tercihleri'nden pazarlama iletilerini kapatabilir veya İYS (İleti Yönetim Sistemi) üzerinden red edebilirsiniz." },
      { h: "Zorunlu İletişim", p: "Sınav hatırlatma, başvuru durumu, ödeme onayı ve güvenlik uyarıları izin kapsamı dışındadır; hizmetin ifası için gönderilir." },
    ],
  },
  "erisilebilirlik": {
    title: "Erişilebilirlik Beyanı",
    seoTitle: "Erişilebilirlik — SanoStudent",
    description: "SanoStudent erişilebilirlik ilkelerimiz.",
    hero: "Platformumuzun herkes tarafından erişilebilir olmasını hedefliyoruz.",
    sections: [
      { h: "İlkeler", p: "WCAG 2.1 AA seviyesini hedefliyoruz: yeterli renk kontrastı, klavye navigasyonu, ekran okuyucu etiketleri, ölçeklenebilir tipografi." },
      { h: "Devam Eden İyileştirmeler", p: "Alt metinler, ARIA rollerinin genişletilmesi, video altyazıları ve odak göstergeleri düzenli olarak iyileştirilmektedir." },
      { h: "Geri Bildirim", p: `Erişilebilirlik sorunlarınızı ${EMAIL} adresine bildirin; en geç 14 gün içinde geri döneriz.` },
    ],
  },
};
